import { ISubAccountData } from "@/store/SubAccountStore";
import { TextButton } from "@/pages/child-customer/atom";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Modal } from "@/components/renderbus-modal";
import styled, { createGlobalStyle } from "styled-components";
import request from "project-config/services/request/request";
import { Radio } from "@renderbus/ui";
import { CloseCircleFilled, PlusCircleFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { Button } from "@renderbus/ui";
import { Tag } from "antd";
import CloseIcon from "./close-icon";
import { PatternMatch } from "project-config/utils";
export interface IIp {
  channel: number;
  id: number;
  ip: string;
  sign: number;
  type: number;
  userId: number;
}

export function SafetySettingButton({ onClick }: { onClick: () => void }) {
  const t = getTranslateNsT("center");
  return (
    <Fragment>
      <TextButton type="text" onClick={onClick}>
        {t("user_com_childManage_del_render_btn_safety")}
      </TextButton>
    </Fragment>
  );
}

export function SafetySettingModal({
  open,
  setOpen,
  ...row
}: ISubAccountData & {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const t = getTranslateNsT("center");
  const { t: centerT } = useTranslation("error");
  const [openAdd, setOpenAdd] = useState(false);
  const [inputIp, setInputIp] = useState("");
  const [inputIpList, setInputIPList] = useState<string[]>([]);
  const [showErrorTip, setShowErrorTip] = useState(false);
  const [currentIp, setCurrentIp] = useState("");
  const [limitType, setLimitType] = useState("1");
  const [ipList, setIpList] = useState<IIp[]>();
  const [subuserEffective, setSubuserEffective] = useState(false);

  async function onPen() {
    const { data } = await request.post("/api/rendering/user/getUserIp");
    setCurrentIp(data);
  }
  async function handleLimitTypeChange(e: any) {
    const res = await request.post("/api/rendering/user/updateLimitIpType", {
      sign: e.target.value,
      userId: row.id,
    });
    setLimitType(e.target.value);
    showLimitedIP(e.target.value);
    res.result && message.success(centerT(`update_success`));
  }
  async function init() {
    await onPen();
    const { data } = await request.post(
      "/api/rendering/user/queryIpLimitType",
      {
        sign: +limitType,
        userId: row.id,
      }
    );
    const {
      data: { subuserEffective },
    } = await request.post("/api/rendering/user/checkSubLimitEffective");
    setSubuserEffective(Boolean(subuserEffective));
    setLimitType(String(data.limitType));
    showLimitedIP(String(data.limitType));
  }
  async function showLimitedIP(type?: string) {
    const { data } = await request.post("/api/rendering/user/showLimitIp", {
      sign: type ?? limitType,
      userId: row.id,
    });
    setIpList(data);
  }
  async function handleDelete(item: IIp) {
    const res = await request.post("/api/rendering/user/delLimitIP", {
      id: item.id,
      userId: row.id,
    });
    if (res.result) {
      message.success(t("user_deleted_success"));
      showLimitedIP();
    }
  }
  async function handleAddIp() {
    if (showErrorTip || (!inputIpList.length && !inputIp)) return;
    const res = await request.post("/api/rendering/user/addLimitIp", {
      channel: 0,
      ipList: inputIpList.length ? inputIpList : [inputIp],
      sign: +limitType,
      type: 1,
      userId: row.id,
    });
    if (res.code === 200) {
      showLimitedIP();
      message.success(t("user_com_childManage_add_success_msg"));
    } else if (res.code === 816) {
      message.error(t("safety_setting_ip_exist"));
    }
    setInputIPList([]);
    setInputIp("");
    setOpenAdd(false);
  }

  const onRemoveTag = (index: number) => {
    setInputIPList(inputIpList.filter((_, i) => i !== index));
  };

  const onInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputIp(value);
    setShowErrorTip(!PatternMatch.isIP(value) && !PatternMatch.isCIDR(value));
  }, []);

  const onPressEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== "Enter") return;
    if (showErrorTip || !inputIp) return;
    if (inputIpList.find((item) => item === inputIp)) {
      setInputIp("");
      return;
    }
    setInputIp("");
    setInputIPList([...inputIpList, inputIp]);
  };

  useEffect(() => {
    if (open) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <>
      <Modal
        open={open}
        className="renderbus-ui--modal safety-setting"
        title={t("user_com_childManage_del_render_btn_safety")}
        children={
          <Fragment>
            <CurrentIp>{`${t(
              "user_setting_current_ip_adress"
            )}：${currentIp}`}</CurrentIp>
            <IPLimitWrapper>
              <span>{t("user_setting_safe_title")}</span>
              <IPLimit>
                <Radio.Group
                  value={limitType}
                  className="safety-setting-radio-group"
                  onChange={handleLimitTypeChange}
                  disabled={subuserEffective}
                >
                  <Radio value={"1"}>{t("user_setting_safe_item_allow")}</Radio>
                  <Radio value={"2"}>
                    {t("user_setting_safe_item_refuse")}
                  </Radio>
                </Radio.Group>
                <IPContainer>
                  {!subuserEffective && (
                    <AddButton
                      onClick={() => setOpenAdd(true)}
                      className={limitType !== "0" ? "" : "turn_gray"}
                      style={{
                        pointerEvents: limitType !== "0" ? "auto" : "none",
                      }}
                    >
                      <PlusCircleFilled />
                      {t("user_setting_safe_ip_add_btn")}
                    </AddButton>
                  )}
                  {ipList?.map((item) => (
                    <IPItem key={item.ip}>
                      <div>{item.ip}</div>
                      {!subuserEffective && (
                        <CloseCircleFilled onClick={() => handleDelete(item)} />
                      )}
                    </IPItem>
                  ))}
                </IPContainer>
              </IPLimit>
            </IPLimitWrapper>
          </Fragment>
        }
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="back" onClick={() => setOpen(false)}>
            {t("user_com_childManage_render_btn_cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={subuserEffective}
            onClick={() => setOpen(false)}
          >
            {t("user_com_childManage_render_btn_comfirm")}
          </Button>,
        ]}
      />
      <Modal
        open={openAdd}
        className="renderbus-ui--modal ip-setting"
        title={t("user_setting_safe_ip_dialog_title")}
        children={
          <IPInputWrapper>
            {inputIpList.map((item, index) => (
              <IpTag
                key={item}
                closable
                closeIcon={<CloseIcon />}
                onClose={() => onRemoveTag(index)}
                onClick={(e) => e.stopPropagation()}
              >
                {item}
              </IpTag>
            ))}
            <IPInput
              value={inputIp}
              onChange={onInput}
              onKeyDown={onPressEnter}
              placeholder={t("user_setting_safe_ip_dialog_item_new")}
            />
            {inputIp && showErrorTip && (
              <ErrorTip>{t("user_setting_safe_ip_dialog_item_error")}</ErrorTip>
            )}
          </IPInputWrapper>
        }
        onCancel={() => {
          setOpenAdd(false);
          setInputIPList([]);
          setInputIp("");
        }}
        onOk={handleAddIp}
      />
      <SafetyStyle />
    </>
  );
}

const CurrentIp = styled.span`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.35);
`;
const SafetyStyle = createGlobalStyle`
  .safety-setting .ant-modal-body {
    padding-top: 17px !important;
  }
  .safety-setting-radio-group {
    display: flex;
    flex-direction: column;
    label {
      margin-bottom: 14px;
    }
  }
  .renderbus-ui--modal.ip-setting {
    .ant-modal-body {
      display: flex;
      justify-content: center;
    }
  }
`;
const IPLimitWrapper = styled.div`
  display: flex;
  margin-top: 16px;
`;
const IPLimit = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
`;
const IPContainer = styled.div`
  background: #29292b;
  border-radius: 2px;
  width: 419px;
  height: 209px;
  overflow: auto;
`;
const IPItem = styled.div`
  height: 40px;
  padding: 9px 0 9px 16px;
  position: relative;
  display: flex;
  align-items: center;
  span {
    position: absolute;
    right: 20px;
  }
  &:hover {
    background: #414144;
    svg {
      color: rgba(255, 0, 0, 0.5);
    }
  }
`;
const AddButton = styled.div`
  height: 40px;
  padding: 9px 0 9px 16px;
  display: flex;
  align-items: center;
  background: #414144;
  color: var(--main-color);
  cursor: pointer;
  span {
    margin-right: 5px;
  }
  &.turn_gray {
    opacity: 0.5;
    cursor: "not-allowed";
  }
`;
const IPInputWrapper = styled.div`
  cursor: text;
  position: relative;
  min-width: 400px;
  max-width: 400px;
  min-height: 30px;
  border: 1px solid #595b61;
  padding: 4.5px 11px;
  border-radius: 4px;
  margin: 10px 0;
  display: flex;
  flex-flow: wrap;
  row-gap: 6px;
  column-gap: 8px;
  box-sizing: border-box;
`;

const IpTag = styled(Tag)`
  position: relative;
  width: 120px;
  height: 21px;
  display: flex;
  padding: 0 3px;
  align-items: center;
  background: #464d56;
  border: unset;
  border-radius: 2px;
  color: #deeaec;
  font-size: 12px;
  line-height: 1;
  margin: 0;
  .ant-tag-close-icon {
    position: absolute;
    top: 50%;
    right: 3px;
    transform: translate(0, -50%);
  }
`;
const ErrorTip = styled.div`
  position: absolute;
  left: 0;
  bottom: -5px;
  color: red;
  transform: translate(0, 100%);
`;
const IPInput = styled.input`
  all: unset;
  flex: 1;
  background: unset;
  color: #deeaec;
  font-size: 12px;
  width: 120px;
  height: 21px;
`;
